import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface ClientHistoryState {
  questionnaireResponse: QuestionnaireResponse | undefined;
}

const initialState: ClientHistoryState = { questionnaireResponse: undefined };

const reducers = {
  updateQuestionnaireResponse: (
    state: ClientHistoryState,
    action: PayloadAction<QuestionnaireResponse | undefined>,
  ) => {
    state.questionnaireResponse = action.payload;
  },
};

const clientHistorySlice = createSlice({
  name: "clientHistory",
  initialState,
  reducers,
});

export const { updateQuestionnaireResponse } = clientHistorySlice.actions;

export const selectQuestionnaireResponse = (state: RootState) =>
  state.clientHistory.questionnaireResponse;

export default clientHistorySlice.reducer;
